module.exports = __webpack_public_path__ + "static/media/arrow.2d56f604.svg";